import { render, staticRenderFns } from "./HYGB6.vue?vue&type=template&id=771c979c"
import script from "./HYGB6.vue?vue&type=script&lang=js"
export * from "./HYGB6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports